/**
 * Copyright (c) 2024 Spazious, Inc All Rights Reserved
 * Proprietary and confidential
 *
 * Written by Rubeniskov <ruben.lopez@spazious.com>, Fri Feb 16 2024
 */

import { Vector3Tuple } from 'three';

/**
 * Type guards for Vector3Tuple
 */
export const isVector3Tuple = (p: any): p is Vector3Tuple =>
  Array.isArray(p) &&
  p.length === 3 &&
  typeof p[0] === 'number' &&
  typeof p[1] === 'number' &&
  typeof p[2] === 'number';
